<!-- <p>chat-message works!</p> -->
<div class="chat-container">

    <!-- SIDEBAR -->
    <!--  <div class="sidebar">
        <h3 class="sidebar-title">History</h3>

        <ul class="chat-history">
            <li *ngFor="let chat of chatHistory; let i=index" [class.active]="i === selectedChatIndex"
                (click)="loadChat(chat, i)">
                {{ chat.question }}
            </li>
        </ul>
    </div> -->
    <div class="sidebar">
        <div class="sidebar-header">
            <h3 class="sidebar-title">History</h3>
            <button class="clear-history-btn" *ngIf="chatHistory.length>0" (click)="clearHistory()">
                Clear
            </button>
        </div>

        <ul class="chat-history">
            <li *ngFor="let chat of chatHistory; let i = index" [class.active]="i === selectedChatIndex"
                (click)="copytoHistory(chat,i)" [title]="chat.tooltip">
                {{ chat.question }}
            </li>
        </ul>
    </div>


    <!-- MAIN CHAT PANEL -->
    <div class="chat-panel">

        <!-- Header -->
        <div class="chat-header">
            <h2>AI Assistant</h2>

            <div class="credits-box">
                @if(this.currentUserData.currentUserRoleDetails.role == Roles.CONSUMER){
                <span>Balance: {{ credits }} Credits</span>
                <button class="recharge-btn" (click)="recharge(addAdvertismentModal)">Recharge</button>
                }
                @if(messages.length>0){ <button class="recharge-btn danger-btn" (click)="clearChat()">Clear</button>}
            </div>



        </div>

        <!-- Chat Messages -->
        <div class="chat-body" #chatBody>
            <div *ngFor="let msg of messages" class="message-row"
                [ngClass]="msg.from === 'user' ? 'row-user' : 'row-bot'">

                <div class="message-box" [ngClass]="msg.from === 'user' ? 'user-box' : 'bot-box'">

                    <span class="copy-btn" (click)="copyMessage(msg.raw)">
                        <i class="fa fa-copy"></i>
                    </span>

                    <div class="msg-text" [innerHTML]="msg.text"></div>
                    <div class="msg-time">{{ formatTimeOnly(msg.time)}}</div>
                </div>
            </div>
        </div>

        <!-- Footer -->
        <div class="chat-footer">
            <div class="message-input-wrapper">
                <input type="text" [(ngModel)]="newMessage" placeholder="Type your message..."
                    (keyup.enter)="sendQuestion()" (input)="onMessageInput()">
                @if (sendClicked && messageErrorType === 'empty') {
                <div class="validation-msg">Please enter a message.</div>
                } @else if (sendClicked && messageErrorType === 'spaces') {
                <div class="validation-msg">Spaces are not allowed please enter valid message.</div>
                }
            </div>

            <button (click)="sendQuestion()">Send</button>
        </div>
        <div>
            <p class="note">Note: This AI Assistant is designed to help you with information related only to Bills,
                Wallet, Statements, Profile details, FAQs, and Notifications. You can search and view content strictly
                within these categories.</p>
        </div>
    </div>

</div>




<!-- Add Advertisment modal -->
<ng-template #addAdvertismentModal>
    <div class="modal-lg">
        <div class="modal-content">
            <div class="modal-header bg-primary text-white">

                <h5 class="modal-title">Token Recharge</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                    (click)="closeModel()"></button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <form [formGroup]="rechargeForm">
                        <div class="balance-row">
                            <h5>Wallet Balance: {{ userWalletBalance }}</h5>

                            <!--  <h5 *ngIf="userWalletBalance < selectedToken?.price">
                                <a routerLink="/consumerWallet" class="recharge-link">Go to recharge</a>
                            </h5> -->
                        </div>

                        <hr>
                        <div class="col-sm-12 col-md-12 col-lg-12">
                            <div class="row">
                                <div class="mb-3 col-lg-12">

                                    <label>Select Tokens</label>
                                    <ng-select [items]="tokenList" bindLabel="tokens" bindValue="id" id="tokens"
                                        [multiple]="false" (change)="onTokenChange($event)" formControlName="tokens"
                                        name='tokens' placeholder="Select tokens" [deselectOnClick]="true"></ng-select>
                                    @if((autosubmitted || rechargeFormControls['tokens'].touched) &&
                                    rechargeFormControls['tokens'].errors){

                                    <div class="invalid-feedback">
                                        @if(rechargeFormControls['tokens'].errors['required']){
                                        <div>{{prifileValidations.token.token}}</div>}
                                    </div>}
                                </div>

                                <div class="mb-3">
                                    <label for="basicpill-declaration-input">Amount (INR)</label>
                                    <ng-select [items]="tokenList" bindLabel="price" bindValue="id" name='amount'
                                        formControlName="amount" placeholder="Select amount" [multiple]="false"
                                        [deselectOnClick]="true"></ng-select>
                                    @if((autosubmitted || rechargeFormControls['amount'].touched) &&
                                    rechargeFormControls['amount'].errors){

                                    <div class="invalid-feedback">
                                        @if(rechargeFormControls['amount'].errors['required']){
                                        <div>{{prifileValidations?.token?.amount}}</div>}
                                    </div>}

                                </div>
                                <div class="mb-3" *ngIf="userWalletBalance < selectedToken?.price">
                                    <p>
                                        Your wallet balance is insufficient for this token purchase.
                                        Please <a routerLink="/consumerWallet" class="recharge-link">Go to recharge</a>
                                        to recharge your wallet and try again.
                                    </p>
                                </div>
                            </div>


                        </div>
                    </form>

                </div>
            </div>

        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-primary waves-effect waves-light" (click)="purchaseToken()"
                [disabled]="userWalletBalance < selectedToken?.price">Purchase</button>


        </div>

    </div><!-- /.modal -->

</ng-template>
